import { Link } from "react-router-dom";
import { categories } from "@/mocks/clueData";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CategoryGrid() {
  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-16 md:px-8 md:py-20">
        <SectionHeading
          align="center"
          eyebrow="找到你关心的"
          icon="ri-layout-grid-line"
          title="主题分类一览"
          desc="从身边小事到行业观察，投稿被归入不同主题，方便你按兴趣浏览。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/clues?category=${cat.id}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                <i className={`${cat.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-700">
                {cat.name}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{cat.summary}</p>
              <span className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                <span>{cat.count} 篇投稿</span>
                <i className="ri-arrow-right-up-line text-base text-primary-600 transition-transform group-hover:translate-x-0.5"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}